import { render, staticRenderFns } from "./main.vue?vue&type=template&id=2d5d485a"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d5d485a')) {
      api.createRecord('2d5d485a', component.options)
    } else {
      api.reload('2d5d485a', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=2d5d485a", function () {
      api.rerender('2d5d485a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/element/message-box/src/main.vue"
export default component.exports